import {Routes} from "@angular/router";
import {LayoutComponent} from "./component/layout/layout.component";
import {authGuard} from "../core/auth/auth.guard";
import {HomePage} from "./page/home-page/home.page";
import {ContractComponent} from "../cross/contracts/component/contract/contract.component";
import {ContractsPage} from "./page/contracts-page/contracts.page";
import {TicketComponent} from "../cross/tickets/component/ticket/ticket.component";
import {SettingsPage} from "../us/page/settings/settings.page";
import {ProfileComponent} from "../us/component/profile/profile.component";
import {ChangePasswordComponent} from "../us/component/change-password/change-password.component";
import {UsNotificationsComponent} from "../us/component/notifications/us-notifications.component";
import {UpdateEmailComponent} from "../us/component/update-email/update-email.component";
import {UpdatePhoneComponent} from "../us/component/update-phone/update-phone.component";
import {settingsUpdateGuard} from "../us/guard/settings-update.guard";
import {DeleteAccountComponent} from "../us/component/delete-account/delete-account.component";
import {AppInfoComponent} from "../us/component/app-info/app-info.component";
import {TermsAndConditionsComponent} from "../us/component/terms-and-conditions/terms-and-conditions.component";
import {PrivacyPolicyComponent} from "../us/component/privacy-policy/privacy-policy.component";
import {ReferFriendComponent} from "../us/component/refer-friend/refer-friend.component";
import {MyContractsPage} from "./page/my-contracts-page/my-contracts.page";
import {DocumentsPage} from "./page/documents-page/documents.page";
import {AgbInfoComponent} from "../us/component/agb/agb-info.component";

export function DsSubRoutes() : Routes {

  /**
   *
   * path:
   * Prefix of the module will always be added to the path name
   *
   *      Example
   *      path: "addresses" => route path "ad/addresses" !
   * ------------------------------------------------------------------
   *
   * component:
   * Added components need to be from type "Page"!
   * ------------------------------------------------------------------
   *
   */
  const routes: Routes = [
    { path: 'ext_mycontracts', component: MyContractsPage, canActivate: [authGuard] },
    {
      path: 'ds', component: LayoutComponent, canActivate: [authGuard],

      children: [
          { path: 'home', component: HomePage  },
          { path: 'contracts', component: ContractsPage  },
          { path: 'my-contracts', component: MyContractsPage  },
          { path: 'contract/:id/:source', component: ContractComponent },
          { path: 'ticket/:id/:source', component: TicketComponent },
          { path: 'documents', component: DocumentsPage},
          { path: 'us', component: SettingsPage, children : [
              { path: 'change-password', component: ChangePasswordComponent},
              { path: 'notifications', component: UsNotificationsComponent},
              { path: 'profile', component: ProfileComponent},
              { path: 'update-email', component: UpdateEmailComponent, canActivate:[settingsUpdateGuard]},
              { path: 'update-phone', component: UpdatePhoneComponent, canActivate:[settingsUpdateGuard]},
              { path: 'delete-account', component: DeleteAccountComponent},
              { path: 'app-info', component: AppInfoComponent},
              { path: 'agb', component: AgbInfoComponent},
              { path: 'terms', component: TermsAndConditionsComponent},
              { path: 'privacy-policy', component: PrivacyPolicyComponent},
              { path: 'refer-friend', component: ReferFriendComponent},
            ]},
      ]
    }


  ];

  return routes;

}
